var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.417 6.35a.863.863 0 0 1-.082 1.216l-9.224 8.05a.987.987 0 0 1-1.333-.031L2.628 11.6a.862.862 0 1 1 1.195-1.244l3.662 3.516L16.2 6.267a.863.863 0 0 1 1.217.083",
    clipRule: "evenodd"
  })));
};
export default SvgTick;